module.exports = __webpack_public_path__ + "img/lideranca_prata.2364b056.png";